import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { addDays } from 'date-fns';
import { MAX_EXPIRATION_DAYS } from '../../common/constants/components';

type InformationRequestExpirationDatePickerProps = {
  value: Date | null;
  onChange: (value: Date | null) => void;
  disabled?: boolean;
  id: string;
  label?: string;
};

const InformationRequestExpirationDatePicker = ({
  value,
  onChange,
  disabled = false,
  id,
  label,
}: InformationRequestExpirationDatePickerProps) => (
  <DatePicker
    label={label}
    value={value}
    onChange={onChange}
    disablePast
    maxDate={addDays(new Date(), MAX_EXPIRATION_DAYS)}
    format="MM/dd/yyyy"
    disabled={disabled}
    slotProps={{
      textField: {
        size: 'small',
        id,
        inputProps: { 'data-testid': id },
      },
    }}
  />
);

export default InformationRequestExpirationDatePicker;
